import { render, staticRenderFns } from "./ContractInfo.vue?vue&type=template&id=3bf3292e&"
import script from "./ContractInfo.vue?vue&type=script&lang=js&"
export * from "./ContractInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VListGroup } from 'vuetify/lib/components/VList';
installComponents(component, {VContainer,VListGroup})
